import { createReducer } from 'store/createReducer';
import { FAVOURITES_REMOVE, FavouritesAction } from 'components/Favourites/actions';
import { FavouritesPageModel } from 'models/FavouritesPageModel';
import initialPageState from 'components/Pagelayout/initialPageState';

const initialState = {
  ...initialPageState,
  favouritesList: [],
  basedOnFavourites: []
};

const reducer = {
  [FAVOURITES_REMOVE]: (
    state: FavouritesPageModel,
    action: FavouritesAction
  ): FavouritesPageModel => ({
    ...state,
    favouritesList: state.favouritesList?.filter(favourite => favourite.productId !== action.id)
  })
};

export default createReducer<FavouritesPageModel>(initialState, reducer);
